const STORAGE_VERSION = 1;
const KEY_PREFIX = "easyMaps:localConfig:v1";

function getUserId() {
  try {
    const raw = localStorage.getItem("1");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return (
      parsed?.refreshToken?.usuarioClienteId ??
      parsed?.usuarioCliente?.id ??
      null
    );
  } catch {
    return null;
  }
}

// isPublic: link público usa um escopo próprio por mapa, sem usuário logado,
// para não misturar com a config local do usuário no privado
function buildKey(mapId, isPublic = false) {
  const userId = isPublic ? "public" : getUserId();
  if (!userId || !mapId) return null;
  return `${KEY_PREFIX}:${userId}:${mapId}`;
}

export function getLocalMapConfig(mapId, isPublic = false) {
  try {
    const key = buildKey(mapId, isPublic);
    if (!key) return null;
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== STORAGE_VERSION) return null;
    return parsed.configuracoes ?? null;
  } catch {
    return null;
  }
}

export function setLocalMapConfig(mapId, configuracoes, isPublic = false) {
  try {
    const key = buildKey(mapId, isPublic);
    if (!key) return false;
    const value = JSON.stringify({
      version: STORAGE_VERSION,
      updatedAt: new Date().toISOString(),
      configuracoes,
    });
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function removeLocalMapConfig(mapId, isPublic = false) {
  try {
    const key = buildKey(mapId, isPublic);
    if (!key) return;
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function hasLocalMapConfig(mapId, isPublic = false) {
  try {
    const key = buildKey(mapId, isPublic);
    if (!key) return false;
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed?.version === STORAGE_VERSION;
  } catch {
    return false;
  }
}

/**
 * Resolves the base configurationMap object from the server response or global config fallback.
 * Does NOT apply local override — call getLocalMapConfig separately and merge if present.
 */
export function resolveBaseConfig(serverConfigMap, globalConfig, tipo) {
  if (serverConfigMap) return serverConfigMap;
  if (tipo === "ftth") {
    const g = globalConfig?.configuracoes;
    return {
      configuracoes: {
        animacao: g?.ftth?.animacao,
        camadaFTTH: {
          filtros: g?.ftth?.camadaFTTH?.filtros,
        },
        esconderOnu: g?.ftth?.esconderOnu,
        showOnusWithoutCto: g?.ftth?.showOnusWithoutCto,
      },
    };
  }
  return { configuracoes: globalConfig?.configuracoes?.[tipo] || null };
}

/**
 * Merges local override on top of a resolved base config.
 * Returns the final configurationMap to pass to setConfigurationMap.
 */
export function applyLocalOverride(base, local) {
  if (!local) return base;
  return {
    ...base,
    configuracoes: { ...base?.configuracoes, ...local },
  };
}
